import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section className="py-20 bg-gray-800">
      <div className="container mx-auto px-6">
        <motion.div
          className="max-w-4xl mx-auto text-center"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="flex flex-col md:flex-row items-center gap-12">
            <motion.div
              className="md:w-1/3"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="relative">
                <div className="w-64 h-64 mx-auto rounded-full bg-gradient-to-br from-[#ffc700] to-[#ffb700] p-1">
                  <div className="w-full h-full rounded-full overflow-hidden bg-gray-800">
                    <img
                      src="https://s3.us-east-1.wasabisys.com/lrcstv/CDN/LRCS-Linda-Central-Park.jpg"
                      alt="Linda Roberts - Scam Buster"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                {/* Floating elements */}
                <div className="absolute -top-4 -right-4 bg-[#ffc700] text-black px-3 py-1 rounded-full text-sm font-bold animate-bounce">
                  NYC
                </div>
                <div className="absolute -bottom-4 -left-4 bg-cyan-400 text-gray-900 px-3 py-1 rounded-full text-sm font-bold animate-pulse">
                  SASS
                </div>
              </div>
            </motion.div>

            <motion.div
              className="md:w-2/3 text-left"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-[#ffc700] to-cyan-400 bg-clip-text text-transparent">
                Meet Linda Roberts
              </h2>
              <p className="text-xl text-gray-300 mb-6 leading-relaxed">
                I'm a street-smart New Yorker with a fierce attitude, flawless delivery, and a mission to expose internet scams. When scammers try to prey on innocent people, I turn the tables with sass, smarts, and style.
              </p>
              <p className="text-lg text-gray-400 leading-relaxed">
                As a digital safety crusader and scam baiter, I protect the vulnerable while entertaining millions. Because sometimes the best defense is a good offense — and a little NYC attitude doesn't hurt either.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;